<template>
    <div class="offers-section">
        <div class="header-block">
            <a class="back-btn" @click="$router.go(-1)">
                <img src="../../../assets/main_images/back-icon.png" alt="back-icon" class="back-icon-image" />
                Back to Search
            </a>
        </div>

        <div class="offers-block">
            <div class="fly-offer-item">
                <template v-if="!destinationsLoaded"><span></span></template>
                <template v-else>
                    <div class="tours-container">
                        <div class="tour-block" v-if="finalModel.tripData.from && finalModel.tripData.to">
                            <div
                                class="location-block"
                                v-if="finalModel.tripData.from.city && finalModel.tripData.from.iata_code"
                            >
                                <div class="name-block">
                                    {{ finalModel.tripData.from.city.toUpperCase() }} -
                                    {{ finalModel.tripData.from.iata_code.toUpperCase() }}
                                </div>
                                <div class="fly-date">{{ formatDate(finalModel.tripData.flyDate) }}</div>
                            </div>

                            <div class="right-arrow">
                                <img
                                    src="../../../assets/svgs/right-vector.svg"
                                    alt="right-vector"
                                    class="right-arrow-image"
                                />
                            </div>

                            <div
                                class="location-block"
                                v-if="finalModel.tripData.to.city && finalModel.tripData.to.iata_code"
                            >
                                <div class="name-block">
                                    {{ finalModel.tripData.to.city.toUpperCase() }} -
                                    {{ finalModel.tripData.to.iata_code.toUpperCase() }}
                                </div>
                                <div class="fly-date"></div>
                            </div>
                        </div>

                        <div class="tour-block" v-if="finalModel.type === 'round_trip'">
                            <div
                                class="location-block"
                                v-if="finalModel.tripData.to.city && finalModel.tripData.to.iata_code"
                            >
                                <div class="name-block">
                                    {{ finalModel.tripData.to.city.toUpperCase() }} -
                                    {{ finalModel.tripData.to.iata_code.toUpperCase() }}
                                </div>
                                <div class="fly-date">{{ formatDate(finalModel.tripData.returnDate) }}</div>
                            </div>

                            <div class="right-arrow">
                                <img
                                    src="../../../assets/svgs/right-vector.svg"
                                    alt="right-vector"
                                    class="right-arrow-image"
                                />
                            </div>

                            <div
                                class="location-block"
                                v-if="finalModel.tripData.from.city && finalModel.tripData.from.iata_code"
                            >
                                <div class="name-block">
                                    {{ finalModel.tripData.from.city.toUpperCase() }} -
                                    {{ finalModel.tripData.from.iata_code.toUpperCase() }}
                                </div>
                                <div class="fly-date"></div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-if="pricesLoaded">
                    <div class="prices-block" v-if="prices">
                        <div class="top-prices-block" v-if="prices.business">
                            <label class="label-container">
                                <input
                                    type="radio"
                                    checked="checked"
                                    name="radio-price"
                                    v-model="finalModel.cabinClass"
                                    :value="'business'"
                                />
                                <div class="texts">
                                    <div class="price">${{ prices.business }} *</div>
                                    <div class="class-type">Business class / {{ typeName }}</div>
                                </div>
                                <span class="checkmark">
                                    <span class="middle-circle"></span>
                                </span>
                                <div class="main-border"></div>
                            </label>

                            <div class="additional-text">BEST</div>
                        </div>

                        <div class="bottom-prices-block">
                            <label class="label-container" v-if="prices.first">
                                <input
                                    type="radio"
                                    checked="checked"
                                    name="radio-price"
                                    v-model="finalModel.cabinClass"
                                    :value="'first'"
                                />
                                <div class="texts">
                                    <div class="price">${{ prices.first }}</div>
                                    <div class="class-type">First class / {{ typeName }}</div>
                                </div>
                                <span class="checkmark">
                                    <span class="middle-circle"></span>
                                </span>
                                <div class="main-border"></div>
                            </label>
                            <div
                                class="middle-line"
                                :class="
                                    finalModel.cabinClass === 'premium_economy' || finalModel.cabinClass === 'first'
                                        ? 'hide'
                                        : ''
                                "
                            ></div>
                            <label class="label-container" v-if="prices.premium_economy">
                                <input
                                    type="radio"
                                    checked="checked"
                                    name="radio-price"
                                    v-model="finalModel.cabinClass"
                                    :value="'premium_economy'"
                                />
                                <div class="texts">
                                    <div class="price">${{ prices.premium_economy }}</div>
                                    <div class="class-type">Premium Economy / {{ typeName }}</div>
                                </div>
                                <span class="checkmark">
                                    <span class="middle-circle"></span>
                                </span>
                                <div class="main-border"></div>
                            </label>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <div class="contacts-info-block">
            <div class="contacts-header">Fill in the request form to receive our special and personalized fares.</div>

            <div class="form-content">
                <SimpleInputField
                    :initial-value="finalModel.personData.name"
                    v-model="finalModel.personData.name"
                    :for-id="'nameOfOffr'"
                    :label-name="'Name'"
                    :placeholder="'Enter your name'"
                    :error="errors.name"
                />
                <SimpleInputField
                    :initial-value="finalModel.personData.email"
                    v-model="finalModel.personData.email"
                    :for-id="'userEmail1'"
                    :type="'email'"
                    :label-name="'Email'"
                    :placeholder="'Enter your email'"
                    :error="errors.email"
                />

                <InputTelField
                    :initial-value="finalModel.personData.phone"
                    :labelName="'Phone'"
                    v-model="finalModel.personData.phone"
                    :for-id="'phoneNumberI'"
                    :placeholder="'Enter your phone'"
                    :error="errors.phone"
                    @valid="is_phone_valid = $event"
                />

                <button
                    class="submit-button"
                    :class="{ loading: is_submiting }"
                    :disabled="is_submiting"
                    @click="validateForm()"
                >
                    <BounceSpinner v-if="is_submiting" color="#fff" />
                    <span v-else>Get The Best Price</span>
                </button>
            </div>

            <div class="information-block">
                *Price shown is a {{ typeName }} fare in business class per person and based on weekday travel
                {Monday-Thursday). The price is total includes all taxes and fees and is in USD. The fares will vary
                based on class of travel availability, airline and city of departure. skiesarebusiness.com will not
                identify all travel partners or details so not to compete with retail sales of our partners. Savings up
                to 60% off are based on un-restricted fares of major airlines and can vary depending on the fare rules.
                All fares are non-refundable and cannot be exchanged or transferred. Please call us directly to check
                the most current prices and availability. Other restrictions may apply. All fares are subject to change
                until ticketed. **By submitting my details I agree to be contacted to discuss my travel plans. Privacy
                Policy
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import _cloneDeep from 'lodash/cloneDeep'
import SimpleInputField from './shared/forms_entities/form-fields/SimpleInputField'
import InputTelField from './shared/forms_entities/form-fields/InputTelField'
import BounceSpinner from './spinners/BounceSpinner'
import { Validators } from './shared/use-cases/validators'
import helper from '@/helper.js'

export default {
    name: 'OffersSection',
    props: ['formValue'],
    components: {
        InputTelField,
        SimpleInputField,
        BounceSpinner,
    },
    data() {
        return {
            is_submiting: false,
            offer: null,
            destinationsLoaded: false,
            pricesLoaded: false,
            prices: {},
            errors: {},
            valid: true,
            typeName: null,
            finalModel: {
                tripData: {
                    flyDate: new Date(),
                },
                cabinClass: null,
                type: null,
                personData: {
                    name: null,
                    phone: null,
                    email: null,
                },
                suid: null,
            },
            is_phone_valid: false,
        }
    },
    async created() {
        if (this.formValue) {
            await this.parseFormData()
            await this.getDestinations()
            await this.getPrices()

            this.finalModel.cabinClass = this.formValue.class
            this.finalModel.passengersCount = this.formValue.passengers

            // Send Ecommerce Product Details event
            if (Object.keys(this.prices).length > 0) {
                for (const cabinC of Object.keys(this.prices)) {
                    this.sendAnalyticsEventProductDetails(cabinC)
                }
            } else {
                this.sendAnalyticsEventProductDetails(this.finalModel.cabinClass)
            }
        }
    },
    methods: {
        formatDate(value) {
            if (value) {
                return moment(value.getTime()).format('DD MMM YY')
            }
        },
        parseFormData() {
            // Search unique ID
            this.finalModel.suid = this.formValue.suid || helper.generateUniqueID()

            this.finalModel.type = this.formValue.type
            this.typeName = this.formValue.type === 'round_trip' ? 'Round Trip' : 'One Way'
            this.finalModel.tripData.flyDate = new Date(this.formValue.flyDate)

            if (this.formValue.type === 'round_trip') {
                this.finalModel.tripData.returnDate = new Date(this.formValue.returnDate)
            }
        },
        async getDestinations() {
            const params = new URLSearchParams()
            params.append('from', this.formValue.from)
            params.append('to', this.formValue.to)

            const response = await axios.get(this.$globalConfig.api.base() + 'a/airports/pair', { params })
            if (response && response.data) {
                this.finalModel.tripData.from = response.data.from
                this.finalModel.tripData.to = response.data.to
            } else {
                alert('Failed to fetch data')
            }
            this.destinationsLoaded = true
        },
        async getPrices() {
            const params = new URLSearchParams()
            params.append('trip_type', this.formValue.type)
            params.append('from', this.formValue.from)
            params.append('to', this.formValue.to)

            try {
                const response = await axios.get(this.$globalConfig.api.base() + 'a/flight/search', { params })

                if (response && response.data) {
                    this.prices = response.data
                }
            } catch (e) {
                //
            }
            this.pricesLoaded = true
        },
        validateForm() {
            this.errors = {}
            this.valid = true

            Object.keys(this.finalModel.personData).map((key) => {
                let validator
                if (key !== 'email') {
                    validator = Validators.required(this.finalModel.personData[key])
                } else {
                    validator = Validators.validateEmail(this.finalModel.personData[key])
                }
                this.errors[key] = validator.error
                if (this.valid) {
                    this.valid = validator.valid
                }
            })

            if (!this.is_phone_valid) this.valid = false

            if (this.valid) {
                this.submitForm()
            }
        },
        submitForm() {
            this.is_submiting = true

            const data = _cloneDeep(this.finalModel)
            data.tripData.from = this.finalModel.tripData.from.iata_code
            data.tripData.to = this.finalModel.tripData.to.iata_code

            // Clean phone
            if (data.personData.phone) data.personData.phone = data.personData.phone.split(/[^\d+]/).join('')

            // Transform data for new api version
            const newData = {
                suid: data.suid,
                trip_type: data.type,
                passengers: {
                    adult: data.passengersCount,
                    child: 0,
                    infant: 0,
                },
                cabin_class: data.cabinClass,
                client: data.personData,
                flight: {
                    from: data.tripData.from,
                    to: data.tripData.to,
                    departure: moment(data.tripData.flyDate.getTime()).format('YYYY-MM-DD'),
                    return:
                        data.type === 'round_trip'
                            ? moment(data.tripData.returnDate.getTime()).format('YYYY-MM-DD')
                            : undefined,
                },
            }

            axios
                .post(this.$globalConfig.api.base() + 'a/create_request', {
                    ...newData,
                    ...this.$root.getMarketingData(),
                })
                .then((response) => {
                    if (response && response.data.success) {
                        helper.yaMetrika.track('reachGoal', 'getthebestprice')

                        this.$root.cleanMarketingData()

                        this.$router.push({
                            path: '/finish',
                            query: {
                                name: this.finalModel.personData.name,
                            },
                        })
                    } else {
                        alert('Error occurred. Please try again or contact us.')
                    }
                })
                .finally(() => {
                    this.is_submiting = false
                })
        },
        sendAnalyticsEventProductDetails(cabinClass) {
            let products = []
            const d = this.finalModel
            const flyDateString = moment(d.tripData.flyDate.getTime()).format('YYYY.MM.DD')
            const returnDateString = d.tripData.returnDate
                ? moment(d.tripData.returnDate.getTime()).format('YYYY.MM.DD')
                : ''

            switch (d.type) {
                case 'round_trip':
                    products = [
                        {
                            name: `${d.tripData.from.iata_code}-${d.tripData.to.iata_code} ${cabinClass.replace(
                                '_',
                                ' '
                            )} ${flyDateString}`.toUpperCase(),
                            id: `${d.tripData.from.iata_code}-${d.tripData.to.iata_code}_${cabinClass}_${flyDateString}`.toLowerCase(),
                            dimension1: d.tripData.from.iata_code.toUpperCase(), // origin
                            dimension2: d.tripData.to.iata_code.toUpperCase(), // destination
                            dimension3: cabinClass.replace('_', ' ').toLowerCase(), // cabin
                            dimension4: d.type, // trip_type
                            dimension5: `${d.tripData.from.iata_code}-${d.tripData.to.iata_code}`.toUpperCase(), // route
                            metric1: parseInt(d.passengersCount), // adult
                            metric2: 0, // child
                            metric3: 0, // infant
                        },
                        {
                            name: `${d.tripData.to.iata_code}-${d.tripData.from.iata_code} ${cabinClass.replace(
                                '_',
                                ' '
                            )} ${returnDateString}`.toUpperCase(),
                            id: `${d.tripData.to.iata_code}-${d.tripData.from.iata_code}_${cabinClass}_${returnDateString}`.toLowerCase(),
                            dimension1: d.tripData.to.iata_code.toUpperCase(), // origin
                            dimension2: d.tripData.from.iata_code.toUpperCase(), // destination
                            dimension3: cabinClass.replace('_', ' ').toLowerCase(), // cabin
                            dimension4: d.type, // trip_type
                            dimension5: `${d.tripData.to.iata_code}-${d.tripData.from.iata_code}`.toUpperCase(), // route
                            metric1: parseInt(d.passengersCount), // adult
                            metric2: 0, // child
                            metric3: 0, // infant
                        },
                    ]
                    break

                case 'one_way':
                    products = [
                        {
                            name: `${d.tripData.from.iata_code}-${d.tripData.to.iata_code} ${cabinClass.replace(
                                '_',
                                ' '
                            )} ${flyDateString}`.toUpperCase(),
                            id: `${d.tripData.from.iata_code}-${d.tripData.to.iata_code}_${cabinClass}_${flyDateString}`.toLowerCase(),
                            dimension1: d.tripData.from.iata_code.toUpperCase(), // origin
                            dimension2: d.tripData.to.iata_code.toUpperCase(), // destination
                            dimension3: cabinClass.replace('_', ' ').toLowerCase(), // cabin
                            dimension4: d.type, // trip_type
                            dimension5: `${d.tripData.from.iata_code}-${d.tripData.to.iata_code}`.toUpperCase(), // route
                            metric1: parseInt(d.passengersCount), // adult
                            metric2: 0, // child
                            metric3: 0, // infant
                        },
                    ]
                    break
            }

            this.$gtm.trackEcommerceEvent(
                {
                    detail: {
                        actionField: {
                            list: 'search result',
                            value: this.prices[cabinClass] ? parseFloat(this.prices[cabinClass]) : undefined,
                        },
                        products,
                    },
                },
                'Product Details',
                true,
                {
                    suid: d.suid,
                }
            )
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'shared/common-forms-styles';

* {
    box-sizing: border-box;
}

.offers-section {
    background-color: white;
    display: flex;
    border-radius: 7px;
    border: 0.5px solid $mainTextBlueColor;
    flex-direction: column;
    margin: 100px auto 40px;
    position: relative;
    max-width: 1100px;
    z-index: 50;

    .header-block {
        padding: 10px 40px 0;
        display: flex;
        width: 100%;

        .back-btn {
            color: $mainTextBlueColor;
            text-decoration: none;
            font-family: 'Gilroy-SemiBold', sans-serif;
            font-size: 12px;
            line-height: 14px;
            margin: 15px 0;
            display: flex;
            align-items: center;
            cursor: pointer;

            .back-icon-image {
                max-height: 10px;
                margin-right: 10px;
            }
        }
    }

    .offers-block {
        padding: 0 40px;
        margin-bottom: 20px;

        .fly-offer-item {
            display: flex;
            align-items: center;

            .tours-container {
                display: flex;
                flex-direction: column;

                .tour-block {
                    display: flex;
                    flex-direction: row;
                    margin: 15px 0;

                    .location-block {
                        color: $mainTextBlueColor;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        flex: 1 1 0;

                        &:hover {
                            background: rgba(255, 255, 255, 0.2);
                        }

                        .name-block {
                            font-family: 'Gilroy-SemiBold', sans-serif;
                            font-size: 26px;
                            line-height: 31px;
                        }

                        .fly-date {
                            font-family: 'Gilroy-Regular', sans-serif;
                            font-size: 14px;
                            line-height: 17px;
                            margin-top: 10px;
                        }
                    }

                    .right-arrow {
                        margin: 0 30px;
                        color: $mainTextBlueColor;
                        display: flex;
                        align-items: center;

                        .right-arrow-image {
                            max-width: 20px;
                            margin-top: -10px;
                        }
                    }
                }
            }

            .prices-block {
                display: flex;
                flex-direction: column;
                margin-left: 90px;

                .top-prices-block,
                .bottom-prices-block {
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;

                    // this block exist only in top-prices-block
                    .additional-text {
                        font-family: 'Gilroy-SemiBold', sans-serif;
                        font-size: 18px;
                        text-align: left;
                        color: $mainTextBlueColor;
                        padding: 30px 10px 10px 30px;
                    }

                    .middle-line {
                        margin: 20px 0;
                        width: 0.5px;
                        background: #cbcbcb;

                        &.hide {
                            opacity: 0;
                        }
                    }
                }

                .label-container {
                    box-sizing: border-box;
                    display: block;
                    position: relative;
                    padding: 15px 18px 15px 48px;
                    cursor: pointer;
                    border-right: 4px;
                    -webkit-user-select: none;
                    -moz-user-select: none;
                    -ms-user-select: none;
                    user-select: none;
                    max-width: 250px;
                    max-height: 220px;
                    min-height: 87px;

                    .main-border {
                        z-index: -1;
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        border-radius: 4px;
                    }

                    .texts {
                        .price {
                            font-family: 'Gilroy-SemiBold', sans-serif;
                            color: $mainTextBlueColor;
                            font-size: 25px;
                            line-height: 30px;
                        }

                        .class-type {
                            font-family: 'Gilroy-Regular', sans-serif;
                            color: $mainTextBlueColor;
                            font-size: 12px;
                            line-height: 14px;
                            margin-top: 7px;
                        }
                    }

                    .checkmark {
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                        left: 17px;
                        height: 16px;
                        width: 16px;
                        background-color: transparent;
                        border-radius: 50%;
                        border: 0.5px solid $mainTextBlueColor;

                        .middle-circle {
                            background: transparent;
                            margin: 5px;
                            width: 4px;
                            height: 4px;
                            position: absolute;
                            border-radius: 50%;
                        }

                        &:after {
                            top: 9px;
                            left: 9px;
                            width: 16px;
                            height: 16px;
                            border-radius: 50%;
                            background: black;
                        }
                    }

                    input {
                        position: absolute;
                        opacity: 0;
                        cursor: pointer;

                        &:checked ~ .checkmark {
                            border: 0.5px solid $mainTextWhiteColor;

                            .middle-circle {
                                background: $mainTextWhiteColor;
                                margin: 5px;
                                width: 4px;
                                height: 4px;
                            }

                            &:after {
                                display: block;
                            }
                        }

                        &:checked + .texts {
                            .price {
                                color: $mainTextWhiteColor;
                                font-size: 30px;
                                line-height: 36px;
                            }

                            .class-type {
                                font-size: 12px;
                                line-height: 14px;
                                color: $mainTextWhiteColor;
                            }
                        }

                        &:checked ~ .main-border {
                            border-radius: 4px;
                            background: transparent
                                linear-gradient(249deg, #fec183 0%, #fea880 17%, #fe6b7a 54%, #ff1572 100%) 0% 0%
                                no-repeat padding-box;
                        }
                    }

                    &:hover {
                        transform: scale(1.05);
                        transition-duration: 500ms;
                        transition-timing-function: ease;
                    }

                    &:after {
                        content: '';
                        position: absolute;
                        display: none;
                    }
                }
            }
        }
    }

    .contacts-info-block {
        border-top: 1px solid #cbcbcb;
        padding: 20px 40px;
        width: 100%;

        .contacts-header {
            font-family: 'Gilroy-SemiBold', sans-serif;
            font-size: 20px;
            line-height: 24px;
            text-align: left;
            color: $mainTextBlueColor;
        }

        .information-block {
            font-family: 'Gilroy-Regular', sans-serif;
            font-size: 10px;
            line-height: 12px;
            text-align: left;
            color: $mainTextBlueColor;
            margin-top: 30px;
        }

        .form-content {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: center;
            margin-top: 14px;

            .input-block {
                width: 24%;
                flex-basis: unset;
                border: 1px solid #f6f6f9;
                padding: 5px 15px;
                margin-left: 10px;
                border-radius: 6px;

                &:first-child {
                    margin-left: -15px;

                    >>> .error-message {
                        left: 15px;
                    }
                }

                .label {
                    font-family: 'Gilroy-Regular', sans-serif;
                    font-size: 12px;
                    line-height: 14px;
                    text-align: left;
                    color: $mainTextBlueColor;
                }

                >>> .error-message {
                    bottom: -15px;
                }
            }

            .submit-button {
                border-radius: 7px;
                padding: 12px 40px;
                background: $mainTextBlueColor;
                outline: none;
                border: 1px solid $mainTextBlueColor;
                cursor: pointer;
                font-family: 'Gilroy-Bold', sans-serif;
                font-weight: bold;
                color: white;
                text-align: center;
                font-size: 18px;
                line-height: 22px;
                width: 25%;
                margin: 0 auto;

                &:not(:disabled):hover {
                    transform: scale(1.03);
                    transition-duration: 0.3s;
                    cursor: pointer;
                }

                &.loading {
                    cursor: progress;
                }
            }
        }
    }
}

@media (max-width: 1150px) {
    .offers-section {
        .contacts-info-block {
            .form-content {
                .input-block {
                    max-width: 300px;
                    margin: 0;
                    padding: 10px 0;
                }

                .submit-button {
                    padding: 12px 30px;
                    font-size: 16px;
                    line-height: 20px;
                }
            }
        }
    }
}

@media (max-width: 768px) {
    .offers-section {
        display: flex;
        flex-direction: column;
        margin: 45px auto;
        position: relative;
        z-index: 50;

        .header-block {
            padding: 10px 10px 0;

            .back-btn {
                margin: 15px 0;

                .back-icon-image {
                    max-height: 10px;
                    margin-right: 10px;
                }
            }
        }

        .offers-block {
            padding: 0 10px;
            margin-bottom: 20px;

            .fly-offer-item {
                flex-direction: column;

                .tours-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    width: 100%;

                    .tour-block {
                        display: flex;
                        flex-direction: row;
                        margin: 15px 0;
                        background-color: rgba(192, 192, 201, 0.12);
                        padding: 10px 15px;
                        width: 100%;
                        border-radius: 6px;

                        .location-block {
                            color: $mainTextBlueColor;

                            .name-block {
                                font-size: 16px;
                                line-height: 19px;
                            }

                            .fly-date {
                                font-size: 12px;
                                line-height: 14px;
                            }
                        }

                        .right-arrow {
                            margin: 0 10px;

                            .right-arrow-image {
                                max-width: 20px;
                            }
                        }
                    }
                }

                .prices-block {
                    display: flex;
                    margin-left: 0;

                    .label-container {
                        width: 100%;
                        max-width: unset;
                    }

                    .top-prices-block {
                        width: 100%;
                        // this block exist only in top-prices-block
                        .additional-text {
                            display: none;
                        }
                    }

                    .bottom-prices-block {
                        margin-top: 20px;

                        .middle-line {
                            display: none;
                        }

                        .label-container {
                            padding: 10px 13px 10px 43px;

                            .texts {
                                .price {
                                    font-size: 22px;
                                    line-height: 26px;
                                }

                                .class-type {
                                    font-size: 10px;
                                    line-height: 12px;
                                }
                            }

                            input {
                                &:checked + .texts {
                                    .price {
                                        font-size: 26px;
                                        line-height: 30px;
                                    }

                                    .class-type {
                                        font-size: 12px;
                                        line-height: 14px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .contacts-info-block {
            padding: 30px 10px;

            .form-content {
                display: flex;
                align-items: flex-start;
                flex-direction: column;

                .input-block {
                    width: 100%;
                    max-width: unset;
                    padding: 10px 0;
                    margin: 0;
                    border: unset;

                    &:hover {
                        background: unset;
                    }

                    &:first-child {
                        margin-left: 0;

                        >>> .error-message {
                            left: 0;
                        }
                    }

                    .label {
                        font-size: 14px;
                        line-height: 17px;
                    }

                    >>> .error-message {
                        left: 0;

                        bottom: 0;
                    }
                }

                .submit-button {
                    padding: 12px 20px;
                    font-size: 18px;
                    line-height: 22px;
                    width: 100%;
                    margin: 10px 0;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/OffersSection.vue